import { ImageUploadProvider } from 'src/app/shared/hooks/imageUpload';

import { CreatePetitionUpdateContext } from './components/CreatePetitionUpdateForm/context';
import { CreatePetitionUpdateForm } from './components/CreatePetitionUpdateForm/index_new';
import { FilledTemplateNotice } from './components/FilledTemplateNotice/index_new';
import { Header } from './components/Header/index_new';
import { SuggestedTemplateNotice } from './components/SuggestedTemplateNotice/index_new';
import { useUpdateSupporters } from './hooks/useUpdateSupporters';

export function UpdateSupporters() {
	const {
		data: { shouldShowSuggestedTemplateNotice, isTemplateFilled },
		actions: { handleUserClickSuggestionAi },
	} = useUpdateSupporters();

	return (
		<section
			aria-labelledby="update-your-supporters-module"
			data-qa="update-your-supporters-module"
			className="bg-background-base p-4 py-8 md:px-12 md:pb-12 md:pt-8"
		>
			<Header />
			{shouldShowSuggestedTemplateNotice && (
				<SuggestedTemplateNotice data-qa="suggested-template-notice" onClick={handleUserClickSuggestionAi} />
			)}
			{isTemplateFilled && <FilledTemplateNotice />}
			<CreatePetitionUpdateContext.Provider value={isTemplateFilled}>
				<ImageUploadProvider>
					<CreatePetitionUpdateForm />
				</ImageUploadProvider>
			</CreatePetitionUpdateContext.Provider>
		</section>
	);
}
